export default __webpack_public_path__ + "static/media/shoePlaceholder.89b3836c.svg";